import React, { useEffect, useState } from "react";
import LaboralBulkLoadEmployeeTable from './table';
import { validateEmail, validateName } from '../../../../helper/form';
import {
  alertConfirmDelete,
  getDataFilter
} from './config';
import {
  validateIdentifierRepeat,
  validateEmailRepeat
} from './validator';
import { Label } from "reactstrap";
import {
  Button,
  UncontrolledTooltip
} from 'reactstrap';
import swal from "sweetalert2";

const EmployeeBulkLoadTableErrors = (props) => {
  const {
    data,
    handleRetryEmployee,
    isValid,
    customFieldsHeaders,
    currentUser,
    onChangeCellValues
  } = props;

  const [filter, setFilter] = useState([]);

  useEffect(() => {
    setFilter(getDataFilter(data, "error"))
  }, [data, isValid])

  const renderActions = (rowData) => {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <Button
          color="success"
          outline
          className="border-0"
          onClick={(e) => handleRetry(rowData)}
        >
          <i className="fa fa-redo-alt" />
        </Button>
        <Button
          color="danger"
          outline
          className="border-0"
          onClick={(e) => handleDestroyEmployee(rowData)}
        >
          <i className="fas fa-trash-alt" />
        </Button>
        {drawSpanEmployeeNew(rowData)}
      </div>
    );
  }

  const drawSpanEmployeeNew = (row) => {
    if (!validateName(row.controldoc_id)) {
      return (
        <div className="d-inline-block m-2">
          <span id="tooltipTonNewEmployee">
            <i className="fas fa-user-plus text-info" />
          </span>
          <UncontrolledTooltip key={_.uniqueId(row.id)} placement="bottom" target="tooltipTonNewEmployee">
            {I18n.t('actions.create')} {I18n.t('activerecord.models.laboral/employee.one')}
          </UncontrolledTooltip>
        </div>
      )
    }
  }

  const validateEmptyIdentifierRepeat = (row, data) => {
    if (row && row.controldoc_id !== "") {
      return validateIdentifierRepeat(row.identifier, data);
    } else {
      return false;
    }
  }

  const validateFields = (item, row) => {
    return (!validateEmail(item.value) || !validateName(item.name) ||
      validateEmptyIdentifierRepeat(row, data) || validateEmailRepeat(row.value, data))
  }

  const handleRetry = (row) => {
    let listWithoutError = [];
    _.each(_.filter(data, item => item.id === row.id), item => {
      if (validateFields(item, row)) {
        item.state = "error";
      } else if (!validateName(item.controldoc_id)) {
        listWithoutError.push(item);
        item.state = "created";
      } else {
        listWithoutError.push(item);
        item.state = "created";
      }
    })

    if (listWithoutError && listWithoutError.length > 0) {
      handleRetryEmployee(data);
    }
  }

  const handleDestroyEmployee = (row) => {
    swal.fire(alertConfirmDelete()).then((result) => {
      if (result.isConfirmed) {
        let filteredArray = _.filter(data, item => (item.id === row.id) ? item.is_deleted = true : item);
        handleRetryEmployee(filteredArray);
      }
    })
  };

  const drawErrors = () => {
    if (filter && filter?.length > 0) {
      return (
        <LaboralBulkLoadEmployeeTable
          data={filter}
          dataKey="id"
          customFieldsHeaders={customFieldsHeaders}
          currentUser={currentUser}
          actionsRenderer={renderActions}
          onDataChange={onChangeCellValues}
          title={
            <Label className="text-danger mb-2">
              {I18n.t('laboral.bulk.load.employees.form.table_error.title')}  ({`${filter?.length}`}), {I18n.t('laboral.bulk.load.employees.form.table_error.title2')}:
            </Label>
          }
          showErrors={true}
        />
      )
    }
  }

  return (
    <>
      {drawErrors()}
    </>
  )
}

export default EmployeeBulkLoadTableErrors;
